import {
  GET_PROFILE_START,
  GET_PROFILE_ERROR,
  GET_PROFILE_SUCCESS,
  CREATE_PROFILE_START,
  CREATE_PROFILE_ERROR,
  CREATE_PROFILE_SUCCESS,
  CREATE_PROFILE_RESET,
} from "./actionTypes"

const initialState = {
  loading: false,
  isUpdated: false,
  errors: "",
  userDetails: {},
  Profile: {},
  ProfileData: {},
}

const AgentProfilereducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROFILE_START:
      return {
        ...state,
        loading: true,
        isUpdated: false,
      }
    case CREATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: true,
        userDetails: action.payload,
      }
    case CREATE_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        isUpdated: false,
      }
    case CREATE_PROFILE_RESET:
      return {
        ...state,
        isUpdated: false,
        loading: false,
        errors: "",
        userDetails: {},
      }
    case GET_PROFILE_START:
      return {
        ...state,
        loading: true,
        errors: "",
      }
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        Profile: action.payload.user_profile,
        ProfileData: action.payload.user_data,
      }
    case GET_PROFILE_ERROR:
      console.log(action.payload.message)
      return {
        ...state,
        loading: false,
        errors: action.payload.message,
      }
    default:
      return state
  }
}

export default AgentProfilereducer
